import IScheduleSendDetails from "./interfaces/ScheduleSendDetails.interface";

export default class ScheduleSendDetailsModel implements IScheduleSendDetails {
    date: Date;
    hour: number;
    minute: number;

    constructor(
    ) {
        const tomorrow = new Date();
        //tomorrow.setDate(tomorrow.getDate() + 1); //add 1 day

        this.date = tomorrow;// new Date(currentDate.setDate(currentDate.getDate()+1));
        this.hour = 23;//currentDate.getHours();
        this.minute = 59;//currentDate.getMinutes();
    }

    static validateModel(model: IScheduleSendDetails) {
        if (!model) return false;

        if (!model.date) return false;

        const today = new Date();
        //const compareDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59);
        //const modelDate = new Date(model.date.getFullYear(), model.date.getMonth(), model.date.getDate(), model.hour, model.minute);
        //console.debug('selected', modelDate);
        //console.debug('today', today);
        //const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 1);
        //const compareDate = new Date(model.date.getFullYear(), model.date.getMonth(), model.date.getDate(), model.hour, model.minute);
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() -1); 

        if (model.hour >= 0 && model.hour <= 23 &&
            model.minute >= 0 && model.minute <= 59
            && model.date > yesterday
        ) {
            return true;
        }

        //if (model.hour >= 0 && model.hour <= 23 &&
        //    model.minute >= 0 && model.minute <= 59
        //    && modelDate.getTime() > today.getTime()
        //) {
        //    return true;
        //}

        //if (model.hour >= 0 && model.hour <= 23 &&
        //    model.minute >= 0 && model.minute <= 59
        //    && model.date.getTime() > today.getTime()
        //) {
        //    return true;
        //}

        return false;
    }

    //[obsolete: use static validateModel instead]
    isValid(): boolean {
        return ScheduleSendDetailsModel.validateModel(this);
    }
}